<template>
  <connection-success :close-action="closeAction" :buttons="buttons" class="obk-connection-suggestion">
    <template v-slot:title>
      <div class="title">{{title}}</div>
    </template>
    <template v-slot:subtitle>
      <div v-if="hasBankCCAccounts" class="subtitle">
        <span>ראינו שיש לך כרטיסי אשראי שמקושרים לחשבון ב{{sourceName}} שהוספת עכשיו.</span>
        <span class="bold"> כדאי להוסיף גם אותם כבר עכשיו כדי לקבל תזרים מדויק.</span>
      </div>
      <div v-else class="subtitle">
        ככה לא צריך לעדכן סיסמה כל כמה חודשים, אלא רק לחדש את ההסכמה פעם בשנה.
      </div>
    </template>
  </connection-success>
</template>

<script>
import ConnectionSuccess from '@/base-components/ConnectionSuccess';
import AddCredentialsFlow
  from '@/pages/responsive-pages/authenticated/navigation-pages/credentials-settings/add-credentials-flow/AddCredentialsFlow';
import { mapActions } from 'vuex';
import router from '@/router';
import Segment from '@/Segment';

export default {
  name: 'OBKConnectionSuggestion',
  components: {
    ConnectionSuccess,
  },
  props: {
    closeAction: {
      type: Function,
      required: true,
    },
    sourceType: {
      type: String,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
    bankCCAccounts: {
      type: Array,
      required: true,
    },
  },
  created() {
    Segment.trackUserGot('OBKConnectionSuggestionAfterSuccess_Entered', { sourceName: this.sourceName, hasBankCCAccounts: this.hasBankCCAccounts });
  },
  computed: {
    title() {
      return this.hasBankCCAccounts ? 'רוצה להוסיף גם את חשבונות האשראי?' : 'רוצה להחליף בקלות גם את החשבונות האחרים שלך לחיבור ישיר?';
    },
    hasBankCCAccounts() {
      return this.bankCCAccounts?.length;
    },
    buttons() {
      return this.hasBankCCAccounts ? this.connectBankCCButtons : this.connectCredsButtons;
    },
    connectBankCCButtons() {
      return [
        {
          title: 'כן, אני רוצה להוסיף חשבון אשראי',
          action: this.openCCConnectionFlow,
          size: 'small',
        },
        {
          title: 'אני אוסיף אחר כך',
          action: () => {
            Segment.trackUserGot('OBKMigrationBankCCWarning_ConnectLaterClicked', {
              sourceName: this.sourceName,
              hasBankCCAccount: this.hasBankCCAccounts,
            });
            return this.closeAction;
          },
          size: 'small',
          variant: 'secondary',
        },
      ];
    },
    connectCredsButtons() {
      return [
        {
          title: 'כן, אני רוצה להחליף',
          action: this.redirectToCredentialsPage,
          size: 'small',
        },
        {
          title: 'חזרה לתזרים',
          action: this.redirectToCashflow,
          size: 'small',
          variant: 'secondary',
        },
      ];
    },
    sourceName() {
      return this.source.sourceName;
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal', 'closeModal', 'closeAllModals']),
    openCCConnectionFlow() {
      Segment.trackUserGot('OBKMigrationBankCCWarning_ConnectClicked', { sourceName: this.sourceName, hasBankCCAccount: this.hasBankCCAccounts });
      this.closeAllModals();
      this.openModal({
        component: AddCredentialsFlow,
        props: {
          knownSourceType: 'cc',
        },
        popupAlignment: 'full-screen',
      });
    },
    redirectToCredentialsPage() {
      Segment.trackUserGot('OBKMigrationBankCCWarning_ConnectClicked', { sourceName: this.sourceName, hasBankCCAccount: this.hasBankCCAccounts });
      this.closeAllModals();
      router.push({ path: '/credentials' });
    },
    redirectToCashflow() {
      Segment.trackUserGot('OBKMigrationBankCCWarning_ConnectLaterClicked', {
        sourceName: this.sourceName,
        hasBankCCAccount: this.hasBankCCAccounts,
      });
      this.closeAllModals();
      router.push({ path: '/home' });
    },
  },
};
</script>

<style lang="scss" scoped>

.obk-connection-suggestion {
  .title, .subtitle{
    padding: 0 25px;
    line-height: 24px;
  }
}

</style>
